/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2023 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

"use client";

import { Text, View } from "@adobe/react-spectrum";

import style from './side-description.module.scss'

export default function SideDescriptionPanel({ tags = [], description = "" }) {

    return <View UNSAFE_className={style.outerDiv}>
        <View UNSAFE_className={style.innerDiv}>
            {
                description && <Text>
                    {
                        description
                    }
                </Text>
            }
            <View>
                <Text UNSAFE_className={style.hashTag}>
                    {
                        tags.map((item, idx) => {
                            return <span key={idx}>#{item} </span>
                        })
                    }
                </Text>

            </View>

        </View>
    </View>
}